(function () {
  'use strict';

  var attributes = ['src', 'srcset', 'sizes', 'data-src', 'data-srcset', 'data-lazy-src', 'data-original', 'data-zoom', 'data-zoom-image', 'href'];

  function sourceKey(value) {
    if (!value) return '';
    try {
      var url = new URL(value, document.baseURI);
      ['width', 'height', 'crop', 'pad', 'format'].forEach(function (name) { url.searchParams.delete(name); });
      url.searchParams.sort();
      return url.href;
    } catch (_) {
      return value;
    }
  }

  function boot() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var configNode = document.getElementById('lp-preview-config');
    if (!configNode) return;
    var root = configNode.closest('[id^="shopify-section-"]');
    if (!root || !root.querySelector('media-gallery')) return;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    var previewSources = new Set();
    function collect(value) {
      if (typeof value === 'string' && /^(https?:)?\/\//.test(value)) previewSources.add(sourceKey(value));
      else if (value && typeof value === 'object') Object.values(value).forEach(collect);
    }
    collect(config.productFeaturedImage);
    collect(config.productPreviews);
    (config.variants || []).forEach(function (variant) {
      collect(variant.featuredImage);
      collect(variant.previews);
    });
    root.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.id.indexOf('MediaGallery-' + root.id.replace(/^shopify-section-/, '')) !== 0) return;
      if (gallery.lpPortraitGalleryGuard) return;
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      var slides = viewer ? Array.from(viewer.querySelectorAll('[id^="Slide-"][data-media-id]')) : [];
      if (!slides.length) return;
      var previewSlide = slides.find(function (slide) { return slide.querySelector('.product__modal-opener--image img'); });
      if (!previewSlide) return;
      var previewImage = previewSlide.querySelector('img');
      var previewId = previewSlide.dataset.mediaId;
      var selectedId = (slides.find(function (slide) { return slide.classList.contains('is-active'); }) || previewSlide).dataset.mediaId;
      var manual = false;
      var pendingPreview = '';
      var gestureUntil = 0;
      var snapshots = new Map();
      var originalSetMedia;
      var originalSetThumbnail;
      var wrappedSetMedia;
      var wrappedSetThumbnail;
      var disposed = false;
      var framePreviewUrl = '';
      var frameRequest = 0;
      var frameUpdate = null;
      var frameData = new Map();
      var frameImages = new Map();
      var supportsFramePreview = !!root.querySelector('[data-lp-benefits-type="2d"], [data-lp-benefits-type="3d"]');

      function frameReplacement(input) {
        if (frameImages.has(input.value)) return Promise.resolve(frameImages.get(input.value));
        var urls = performance.getEntriesByType('resource').map(function (entry) { return entry.name; }).filter(function (name) {
          try {
            var url = new URL(name);
            return url.hostname === 'apo-admin.mageworx.com' && url.pathname.indexOf('/front/product/') === 0 && url.pathname.split('/').indexOf(String(config.productId)) !== -1;
          } catch (_) { return false; }
        });
        var url = urls[urls.length - 1];
        if (!url) return Promise.resolve('');
        if (!frameData.has(url)) {
          frameData.set(url, fetch(url, { credentials: 'omit', cache: 'force-cache' }).then(function (response) {
            if (!response.ok) throw new Error('Frame configuration unavailable');
            return response.json();
          }).catch(function () { frameData.delete(url); return null; }));
        }
        return frameData.get(url).then(function (data) {
          Object.keys(data && data.values || {}).forEach(function (id) {
            var option = data.values[id];
            var images = option && option.value && option.value.images;
            var image = images && images.find(function (item) { return item.replace && item.url; });
            if (image) frameImages.set(id, image.url);
          });
          return frameImages.get(input.value) || '';
        });
      }

      function requestFramePreview() {
        var request = ++frameRequest;
        var input = root.querySelector('.lp-frame-option input[type="radio"]:checked');
        if (!input || !input.closest('.product__info-container')) return;
        var value = input.value;
        frameReplacement(input).then(function (url) {
          if (!url || disposed || !gallery.isConnected || request !== frameRequest || !input.isConnected || !input.checked || input.value !== value || !originalSetMedia) return;
          try {
            var imageUrl = new URL(url, document.baseURI);
            if (imageUrl.protocol !== 'https:') return;
          } catch (_) { return; }
          observer.disconnect();
          framePreviewUrl = url;
          pendingPreview = '';
          selectedId = previewId;
          manual = true;
          commitPreview(url);
          restore();
          originalSetMedia.call(gallery, previewId, false);
          observe();
        });
      }

      function frameIntent(event) {
        if (!supportsFramePreview || !(event.target instanceof Element)) return;
        var option = event.target.closest('.lp-frame-option');
        if (!option || !root.contains(option) || !option.closest('.product__info-container')) return;
        if (event.type === 'click') {
          var label = event.target.closest('label');
          if (!event.target.matches('input[type="radio"]') && !(label && label.querySelector('input[type="radio"]'))) return;
        } else if (!event.target.matches('input[type="radio"]') || [' ', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) return;
        if (frameUpdate !== null) cancelAnimationFrame(frameUpdate);
        frameUpdate = requestAnimationFrame(function () { frameUpdate = null; if (!disposed) requestFramePreview(); });
      }

      if (supportsFramePreview) {
        root.addEventListener('click', frameIntent, true);
        root.addEventListener('keydown', frameIntent, true);
      }

      function remember(node) {
        var saved = {};
        attributes.forEach(function (name) { saved[name] = node.getAttribute(name); });
        snapshots.set(node, saved);
      }

      slides.forEach(function (slide) {
        slide.querySelectorAll('img, picture source, a[href]').forEach(remember);
      });

      var thumbnail = Array.from(gallery.querySelectorAll('[data-target]')).find(function (item) { return item.dataset.target === previewId; });
      var previewThumbnail = thumbnail && thumbnail.querySelector('img');
      if (previewThumbnail) remember(previewThumbnail);
      var rawId = previewId.substring(previewId.lastIndexOf('-') + 1);
      var modal = document.getElementById('ProductModal-' + root.id.replace(/^shopify-section-/, ''));
      var modalImage = modal && Array.from(modal.querySelectorAll('img[data-media-id]')).find(function (image) { return image.dataset.mediaId === rawId; });
      if (modalImage) remember(modalImage);

      function restore() {
        snapshots.forEach(function (saved, node) {
          attributes.forEach(function (name) {
            if (node.getAttribute(name) === saved[name]) return;
            if (saved[name] === null) node.removeAttribute(name);
            else node.setAttribute(name, saved[name]);
          });
        });
      }

      function setExpectedImage(node, url) {
        if (!node) return;
        var saved = snapshots.get(node);
        if (!saved) return;
        saved.src = url;
        saved.srcset = null;
        saved.sizes = null;
        ['data-src', 'data-srcset', 'data-lazy-src', 'data-original'].forEach(function (name) { saved[name] = null; });
        ['data-zoom', 'data-zoom-image'].forEach(function (name) { if (saved[name] !== null) saved[name] = url; });
      }

      function commitPreview(url) {
        setExpectedImage(previewImage, url);
        setExpectedImage(previewThumbnail, url);
        setExpectedImage(modalImage, url);
        var picture = previewImage.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach(function (source) {
          var saved = snapshots.get(source);
          if (saved) { saved.srcset = url; saved['data-srcset'] = null; }
        });
      }

      function currentPreview() {
        if (framePreviewUrl) return framePreviewUrl;
        var field = root.querySelector('form[action*="/cart/add"] [name="id"]');
        var variant = (config.variants || []).find(function (item) { return field && String(item.id) === field.value; });
        var frame = root.querySelector('.lp-frame-option input:checked');
        var name = frame && frame.getAttribute('aria-label');
        if (!name) return '';
        var normalize = function (value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
        var profile = config.profile || {};
        var slot = Object.keys(profile).find(function (key) { return normalize(profile[key]) === normalize(name); });
        if (!slot) return '';
        if (slot === 'unframed') return (variant && variant.featuredImage) || config.productFeaturedImage || '';
        return (variant && variant.previews && variant.previews[slot]) || (config.productPreviews && config.productPreviews[slot]) || (variant && variant.featuredImage) || config.productFeaturedImage || '';
      }

      function observe() {
        observer.observe(gallery, { attributes: true, subtree: true, attributeFilter: attributes.concat(['class']) });
      }

      var observer = new MutationObserver(function (changes) {
        var next = '';
        changes.forEach(function (change) {
          if (change.attributeName !== 'src' || !snapshots.has(change.target)) return;
          var node = change.target;
          if (node.tagName !== 'IMG' || !viewer.contains(node)) return;
          var url = node.getAttribute('src');
          var expected = snapshots.get(node).src;
          if (sourceKey(url) !== sourceKey(expected) && previewSources.has(sourceKey(url))) next = url;
        });
        observer.disconnect();
        var latest = currentPreview();
        if (!framePreviewUrl && next && (!latest || sourceKey(next) === sourceKey(latest))) {
          pendingPreview = next;
          if (!manual) commitPreview(next);
        }
        restore();
        if (manual && originalSetMedia) {
          var active = viewer.querySelector('.is-active[data-media-id]');
          if (active && active.dataset.mediaId !== selectedId) originalSetMedia.call(gallery, selectedId, false);
        }
        observe();
      });

      function beginManual() {
        frameRequest++;
        var current = gallery.querySelector('[data-target] button[aria-current="true"]');
        var active = viewer.querySelector('.is-active[data-media-id]');
        if (current) selectedId = current.closest('[data-target]').dataset.target;
        else if (active) selectedId = active.dataset.mediaId;
        manual = true;
        gestureUntil = performance.now() + 2000;
      }

      gallery.addEventListener('click', function (event) {
        var target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        var item = target.closest('[data-target]');
        if (item && gallery.contains(item)) {
          frameRequest++;
          selectedId = item.dataset.target;
          manual = true;
          if (selectedId === previewId && pendingPreview) {
            observer.disconnect();
            commitPreview(pendingPreview);
            restore();
            observe();
          }
        } else if (viewer.contains(target)) {
          beginManual();
        }
      }, true);

      gallery.addEventListener('pointerdown', function (event) {
        if (!viewer.contains(event.target)) return;
        beginManual();
      }, { capture: true, passive: true });

      viewer.addEventListener('wheel', beginManual, { passive: true });
      viewer.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) beginManual();
      });

      gallery.addEventListener('slideChanged', function (event) {
        var current = event.detail && event.detail.currentElement;
        if (manual && performance.now() < gestureUntil && current && viewer.contains(current)) selectedId = current.dataset.mediaId;
      }, true);

      customElements.whenDefined('media-gallery').then(function () {
        if (disposed || !gallery.isConnected || typeof gallery.setActiveMedia !== 'function') return;
        originalSetMedia = gallery.setActiveMedia;
        originalSetThumbnail = gallery.setActiveThumbnail;
        wrappedSetMedia = function (id, prepend) {
          if (manual && id !== selectedId) return;
          return originalSetMedia.call(this, id, manual ? false : prepend);
        };
        wrappedSetThumbnail = function (item) {
          if (manual && item && item.dataset.target !== selectedId) return;
          return originalSetThumbnail.call(this, item);
        };
        gallery.setActiveMedia = wrappedSetMedia;
        gallery.setActiveThumbnail = wrappedSetThumbnail;
      });

      gallery.lpPortraitGalleryGuard = {
        getState: function () { return { manual: manual, selectedId: selectedId, previewId: previewId, pendingPreview: pendingPreview }; }
      };
      function unload(event) {
        if (event.target !== root) return;
        disposed = true;
        frameRequest++;
        if (frameUpdate !== null) cancelAnimationFrame(frameUpdate);
        root.removeEventListener('click', frameIntent, true);
        root.removeEventListener('keydown', frameIntent, true);
        observer.disconnect();
        if (gallery.setActiveMedia === wrappedSetMedia) gallery.setActiveMedia = originalSetMedia;
        if (gallery.setActiveThumbnail === wrappedSetThumbnail) gallery.setActiveThumbnail = originalSetThumbnail;
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
      observe();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
